import React, { Component } from 'react'
import { string, number } from 'prop-types'
import { SignCountSpan } from '../styles'

const OrderNumber = ({ orderNumber, objectKey }) => (
  <span className="orderInfo orderNumber">[ {orderNumber} ]</span>
)

const OnStreet = ({ onStreet }) => (
  <span className="orderInfo">ON {onStreet}</span>
)

const BetweenStreet = ({ fromStreet, toStreet }) => (
  <span className="orderInfo">
    FROM {fromStreet} TO {toStreet}
  </span>
)

const PluralizeSigns = ({ signs }) =>
  signs > 1 ? `${signs} signs` : `${signs} sign`

const SignCounts = ({ signs, theme }) => (
  <SignCountSpan theme={theme}>
    <PluralizeSigns signs={signs} />
  </SignCountSpan>
)

const SOS = ({ sos }) => <span className="orderInfo">(Side: {sos})</span>

class OFT extends Component {
  render() {
    const {
      objectKey,
      orderNumber,
      onStreet,
      fromStreet,
      toStreet,
      sos,
      signs,
      theme,
    } = this.props
    return (
      <div className="oft">
        <OrderNumber objectKey={objectKey} orderNumber={orderNumber} />
        <OnStreet onStreet={onStreet} />
        <BetweenStreet fromStreet={fromStreet} toStreet={toStreet} />
        <SOS sos={sos} />
        <SignCounts signs={signs} theme={theme} />
      </div>
    )
  }
}

OFT.propTypes = {
  objectKey: string.isRequired,
  orderNumber: string.isRequired,
  onStreet: string.isRequired,
  fromStreet: string.isRequired,
  toStreet: string,
  sos: string.isRequired,
  theme: string.isRequired,
}

SOS.propTypes = {
  sos: string.isRequired,
}

BetweenStreet.propTypes = {
  fromStreet: string.isRequired,
  toStreet: string,
}

OnStreet.propTypes = {
  onStreet: string.isRequired,
}

OrderNumber.propTypes = {
  objectKey: string.isRequired,
  orderNumber: string.isRequired,
}

SignCounts.propTypes = {
  signs: number.isRequired,
  theme: string.isRequired,
}

export default OFT



// WEBPACK FOOTER //
// ./src/components/List/OrderBar/OFT.jsx